<template>
  <div></div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    resultName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('document', ['fileObj']),
    ...mapState('system', ['routerStatusRedirect']),
  },
  async created() {
    if (!this.fileObj) {
      await this.getDocuments()
    }

    // truthOrFalsehoodOfCertificateOfIncomeAmount
    console.log(`status check ${this.resultName}`)
    if (!this.fileObj?.certificateOfIncomeAmount) {
      const name = 'signup/certification'
      if (this.$route.name !== name && this.routerStatusRedirect) {
        this.$router.replace({ name })
      }
      return
    }

    this.$emit('emitNext', {
      name: this.resultName,
      result: true,
    })
  },
  methods: {
    ...mapActions('document', ['getDocuments']),
  },
}
</script>
